import { useEffect, useState } from "react";
import './ChimeMeetControls.scss';
import { useLocation } from "react-router-dom";
import ConfirmationPopup from "../../ConfirmationPopup/ConfirmationPopup";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { ARE_YOU_SURE_YOU_WANT_TO_END_THIS_SESSION, BUTTON_DISABLED, FETCH_POLICY_NO_CACHE, SCHOOL_ADMIN, TEACHER_ROLE } from "../../../utils/constants";
import images from "../../../assets/images";
import { useMutation } from "@apollo/client";
import { useGlobalState } from "../../../MeetContext/MeetContext";
import { END_THE_LIVE_SESSION } from "../../../pages/LiveClass/api/LiveClassQuery";
import { UPDATE_WORKSHOP_ENDED, UPDATE_WORKSHOP_MEETING_ID } from "../../../pages/Workshop/api/WorkshopQuery";
import MaterialActionsOverlay, { MenuItemType } from "../../ActionsOverlay/MaterialActionsOverlay";
import { UPDATE_MEETING_STATUS } from "../../../pages/AdminPta/api/PtaQuery";
import { isPlatform } from "@ionic/react";
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import ToasterWithMessage from "../../toaster";
import { useAttendeeStatus, useContentShareControls, useLocalVideo, useToggleLocalMute,  useMeetingManager, useRosterState } from "amazon-chime-sdk-component-library-react";
import { useChimeMeeting } from "../../../Chime/ChimeMeetingContext";
import { DELETE_SESSION_PARTICIPANT, UPDATE_LIVECLASS_HOST_ID, UPDATE_SESSION_RECORD } from "../../../Chime/helpers/Api/ChimeApi";
import { setCurrentSessionRecordingDetail, setIsStartingMeeting } from "../../../redux/slices/dashboardSlice";
import { delay, getScreenDimensions } from "../../../utils/helper";
import IconStopRecording from "../../../assets/images/IconStopRecording";
import IconStartRecording from "../../../assets/images/IconStartRecording";
import { Menu, MenuItem } from "@mui/material";
import { closeWindow, getNewHost } from "../../../utils/chimeHelper";
import { getChimeParticipants } from "../../../Chime/helpers/get-participants";
import { deleteChimeAttendee } from "../../../Chime/helpers/delete-attendee";

const ChimeMeetControls = () => {
    const { setOpenShareScreenPopup, openShareScreenPopup, handleParticipantsGridViewToggle, toggleChat, toggleParticipant } = useGlobalState();
    const currentSessionId = useAppSelector((state) => state?.dashboard?.currentSessionId);
    const currentWorkshopId = useAppSelector((state) => state?.dashboard?.currentWorkshopId);
    const currentPtaMeetId = useAppSelector((state) => state?.dashboard?.currentPtaMeetId);
    const currentPtaMeetMCode = useAppSelector((state) => state?.dashboard?.currentPtaMeetMCode);
    const {state: locationState} = useLocation();
    const { role, loginpage } = useAppSelector((state) => state.auth);

  const [openConfirmationPopup, setOpenConfirmationPopup] =
    useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [openOverlay, setOpenOverlay] = useState<boolean>(false);
  const [action, setAction] = useState<string>("");
  const [promptMessage, setPromptMessage] = useState<string>("");
  const { Crying, StopIconRed } = images;
  const { error } = ToasterWithMessage();
  const [openLeaveEndPopup, setOpenLeaveEndPopup] = useState<boolean>(false);
  const {
    MicOff,
    MicOn,
    VideoOn,
    VideoOff,
    EndCall,
    ScreenSharingIcon,
    HandOn,
    HandOff,
    mobileParticipants,
    selectedAllParticipants,
  } = images;
  const selectedSubjectId = localStorage.getItem("selectedSId");
  const selectedClassRoomId = useAppSelector(
    (state) => state.auth.selectedClassRoomId
  );
  const meetComponent = useAppSelector(
    (state) => state?.dashboard?.meetComponent
  );
  const { toggleContentShare } = useContentShareControls();
  const {
    startRecordingInProgress,
    stopRecordingInProgress,
    startRecording,
    stopRecording,
    isRecording,
    leaveMeeting,
    endMeeting,
    attendeeId,
    toggleHandRaise,
    isHandRaised,
    hostId,
    userId,
    isShowParticipants,
    setIsShowParticipants,
    setHostId,
    mediaPipelineArn,
    mediaPipelineId,
    hostAttendeeId,
    setHostAttendeeId,
    meetingId
  } = useChimeMeeting();
  const dispatch = useAppDispatch();
  const { toggleMute } = useToggleLocalMute();
  const { toggleVideo } = useLocalVideo();
  const meetingManager = useMeetingManager();

  const {
    muted,
    videoEnabled,
    sharingContent,
  } = useAttendeeStatus(attendeeId ? attendeeId : "");
  const [anchorElHost, setAnchorElHost] = useState<null | HTMLElement>(null);
  const { roster } = useRosterState();
  const currentSessionDetail = useAppSelector(
    (state) => state?.dashboard?.currentSessionDetail
  );

  const [updateSessionRecord] = useMutation(UPDATE_SESSION_RECORD, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
    },
    onError: (err) => {
      error(err?.message);
    },
  });

  const [updateHostIdForPtaMeeting] = useMutation(UPDATE_MEETING_STATUS, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
        console.log("Pta meeting status updated successfully", data);
    },
    onError: (err) => {
      error(err?.message);
    }
  });
  
  const [updateHostIdForLiveclass] = useMutation(UPDATE_LIVECLASS_HOST_ID, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
          console.log("Liveclass host id updated successfully", data);
        },
        onError: (err) => {
            error(err?.message);
        }
    });

    const [updateWorkshopSessionRecord] = useMutation(UPDATE_WORKSHOP_MEETING_ID, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
        },
        onError: (err) => {
            error(err?.message);
        }
    });

    const [updatePtaSessionRecord] = useMutation(UPDATE_MEETING_STATUS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
        },
        onError: (err) => {
            error(err?.message);
        }
    });

    const [updateSessionEnd] = useMutation(END_THE_LIVE_SESSION, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {}
    });

    const [updateWorkshopEnd] = useMutation(UPDATE_WORKSHOP_ENDED, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {}
    });

    const [updatePtaEnd] = useMutation(UPDATE_MEETING_STATUS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {}
    });

    const handleUpdateParticipantCount = async () => {
        // if(meetComponent === 'liveclass'){
        //     await updateSessionParticipantCount({
        //         variables: {
        //           cId: selectedClassRoomId,
        //           sId: currentSessionId,
        //           sjId: selectedSubjectId,
        //           participanttype: false
        //         }
        //       })
        // }else if(meetComponent === 'workshop'){
        //     await updateWorkshopSessionParticipantCount({
        //         variables: {
        //             input: {
        //                 participantType: false,
        //                 wsId: currentWorkshopId
        //             }
        //         }
        //     })
        // }else if (meetComponent === 'pta') {
        //     await updateMeetParticipantCount({
        //         variables: {
        //             input: {
        //                 mId: currentPtaMeetId,
        //                 participantType: false
        //             }
        //         }
        //     })
        // }
    }
    

    const [deleteSessionParticipant] = useMutation(DELETE_SESSION_PARTICIPANT, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onCompleted: (data) => {
        console.log("Participant deleted successfully:", data);
      },
      onError: (err) => {
        console.log(err)
      },
    });
  
    const onYesButtonClick = async (from: string, actionName: string) => {
        handleUpdateParticipantCount();
        setOpenConfirmationPopup(false);
        dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
        const chimeLocalParticipantId = localStorage.getItem("chimeLocalParticipantId");
        localStorage.setItem("isManualLeft", "yes");
        if(((from === "confirmationPopup") && (action === 'leave')) || ((from === "auto") && (actionName === 'leave'))){
            try {
                if(meetComponent === 'liveclass' && chimeLocalParticipantId){
                  await deleteSessionParticipant({
                    variables: {
                      cId: selectedClassRoomId,
                      sId: currentSessionId,
                      sjId: selectedSubjectId,
                      participantId: `${chimeLocalParticipantId}`,
                    }
                  });
                }
                await leaveMeeting();
            } catch (err) {
                console.error('Failed to leave meeting:', err);
            }
        }else if(((from === "confirmationPopup") && (action === 'end')) || ((from === "auto") && (actionName === 'end'))){
            try {
                const chimeLocalParticipantId = localStorage.getItem("chimeLocalParticipantId");
                if(meetComponent === 'liveclass' && chimeLocalParticipantId){
                  await deleteSessionParticipant({
                    variables: {
                      cId: selectedClassRoomId,
                      sId: currentSessionId,
                      sjId: selectedSubjectId,
                      participantId: `${chimeLocalParticipantId}`,
                    }
                  });
                }
                if(meetComponent === 'liveclass'){
                    updateSessionEnd({
                        variables:{
                        cId:selectedClassRoomId,
                        sId:currentSessionId,
                        sjId:selectedSubjectId
                        }
                    });
                }else if(meetComponent === 'workshop'){
                    updateWorkshopEnd({
                        variables:{
                            wsId:currentWorkshopId
                        }
                    });   
                }else if(meetComponent === 'pta'){
                    updatePtaEnd({
                        variables: {
                          updateInput: {
                            mStatus: "ENDED",
                          },
                          mId: currentPtaMeetId,
                        }
                      });   
                }
                await endMeeting();
            } catch (err) {
                console.error('Failed to leave meeting:', err);
            }
        }
        toggleChat(false);
        toggleParticipant(false);
        handleParticipantsGridViewToggle(false);
        if(userId === hostId && isRecording){
          if(action === "end"){
        const recordingStartTime = new Date().toISOString();
            if (meetComponent === 'liveclass') {
                updateSessionRecord({
                    variables: {
                        cId: selectedClassRoomId,
                        sId: currentSessionId,
                        sjId: selectedSubjectId,
                        isRecordStart: false,
                        recordStarttime: recordingStartTime
                    }
                });
            } else if (meetComponent === 'workshop') {
                updateWorkshopSessionRecord({
                    variables: {
                        updateInput: {
                            isRecordStart: false,
                            recordStartTime: recordingStartTime
                        },
                        wsId: currentWorkshopId
                    }
                });
            } else if (meetComponent === 'pta') {
                updatePtaSessionRecord({
                    variables: {
                        updateInput: {
                            isRecordStart: false,
                            recordStartTime: recordingStartTime
                          },
                          mId: currentPtaMeetId,
                    }
                });
            } else {
                console.log('meet component on yes', meetComponent);
            }
        dispatch(setCurrentSessionRecordingDetail({recordingStartedTime: recordingStartTime, recordingStarted: false}));
          }
             }
        // Close the window instead of navigating
        closeWindow(locationState);
    };

    const onNoButtonClick = () => {
        setOpenConfirmationPopup(false);
        setAction('');
        setPromptMessage('');
    };

    // useEffect(() => {
    //     window.addEventListener("beforeunload", () => {
    //             handleUpdateParticipantCount();
    //     });
    //     window.addEventListener("popstate", () => {
    //             handleUpdateParticipantCount();
    //     });

    //     return () => {
    //         // Clean up the event listeners when the component unmounts
    //         window.removeEventListener('beforeunload', handleUpdateParticipantCount);
    //         window.removeEventListener('popstate', handleUpdateParticipantCount);
    //     };
    // },[]);

  const handleClickEndButton = (event: React.MouseEvent<HTMLElement>) => {
    if(userId === hostId){
      setOpenLeaveEndPopup(true);
      setPromptMessage("Are you sure you want to");
    }else{
    // the below method is consider as leave meeting for non host users
    handleEnd()
    }
  };

  const handleEnd = () =>{
    if (role === TEACHER_ROLE && meetComponent === "liveclass") {
      setPromptMessage(ARE_YOU_SURE_YOU_WANT_TO_END_THIS_SESSION);
      setOpenConfirmationPopup(true);
      setAction("end");
    }
      else if (
      role === SCHOOL_ADMIN &&
      loginpage === SCHOOL_ADMIN &&
      meetComponent === "pta"
    ) {
      setPromptMessage(ARE_YOU_SURE_YOU_WANT_TO_END_THIS_SESSION);
      console.log("pta");
      setOpenConfirmationPopup(true);
      setAction("end");
    } else {
      setPromptMessage("Are you sure you want to Leave this Session?");
      setOpenConfirmationPopup(true);
      setAction("leave");
    }
  }

  const handleCloseActions = () => {
    setAnchorEl(null);
    setOpenOverlay(false);
  };

  const menuItems: MenuItemType[] = [
    {
      label: "Leave",
      onClick: () => {
        setAction("leave");
        setPromptMessage("Are you sure you want to Leave this Session?");
        setOpenConfirmationPopup(true);
        handleCloseActions();
      },
    },
    {
      label: "End meeting",
      onClick: () => {
        setAction("end");
        setPromptMessage(ARE_YOU_SURE_YOU_WANT_TO_END_THIS_SESSION);
        setOpenConfirmationPopup(true);
        handleCloseActions();
      },
    },
  ];

  const handleStartRecording = () => {
    console.log("inside handleStartRecording=========>");
    if (isRecording) {
      error("The meeting is already being recorded.");
    } else {
      const recordingStartTime = new Date().toISOString();
      const currentMeetId = (meetComponent === 'liveclass') ? currentSessionId :
        (meetComponent === 'workshop') ? currentWorkshopId :
        (meetComponent === 'pta') ? currentPtaMeetId : '';
        console.log("the current meed id based on meet component is ", currentMeetId);
      startRecording(recordingStartTime, currentMeetId);
      if (meetComponent === 'liveclass') {
          updateSessionRecord({
              variables:{
                  cId: selectedClassRoomId,
                  sId: currentSessionId,
                  sjId: selectedSubjectId,
                  isRecordStart: true,
                  recordStarttime: recordingStartTime
              }
          });
      } else if (meetComponent === 'workshop') {
      updateWorkshopSessionRecord({
        variables: {
          updateInput: {
            isRecordStart: true,
            recordStartTime: recordingStartTime,
          },
          wsId: currentWorkshopId,
        },
      });
      } else if (meetComponent === 'pta') {
          updatePtaSessionRecord({
              variables:{
                  updateInput: {
                      isRecordStart: true,
                      recordStartTime: recordingStartTime
                    },
                    mId: currentPtaMeetId,
              }
          });
      } else {
          console.log('meet component', meetComponent);
      }
      dispatch(
        setCurrentSessionRecordingDetail({
          recordingStartedTime: recordingStartTime,
          recordingStarted: true,
        })
      );
    }
  };

  const handleStopRecording = () => {
    const recordingStopTime = new Date().toISOString();
    stopRecording();
    if (meetComponent === 'liveclass') {
          updateSessionRecord({
              variables:{
                  cId: selectedClassRoomId,
                  sId: currentSessionId,
                  sjId: selectedSubjectId,
                  isRecordStart: false,
                  recordStarttime: recordingStopTime
              }
          });
      } else if (meetComponent === 'workshop') {
      updateWorkshopSessionRecord({
        variables: {
          updateInput: {
            isRecordStart: false,
            recordStartTime: recordingStopTime,
          },
          wsId: currentWorkshopId,
        },
      });
      } else if (meetComponent === 'pta') {
          updatePtaSessionRecord({
              variables:{
                  updateInput: {
                      isRecordStart: false,
                      recordStartTime: recordingStopTime
                    },
                    mId: currentPtaMeetId,
              }
          });
      } else {
          console.log('meet component', meetComponent);
      }
    dispatch(
      setCurrentSessionRecordingDetail({
        recordingStartedTime: recordingStopTime,
        recordingStarted: false,
      })
    );
  };

  const handleShareScreen = () => {
    handleParticipantsGridViewToggle(false);
    if (window.electron && window.electron.isElectron() && !sharingContent) {
      setOpenShareScreenPopup(!openShareScreenPopup);
    } else {
      toggleContentShare();
    }
  };

  const handleCloseMenu = () => {
    setAnchorElHost(null);
  };

  const handleLeaveMeetingHost = async () => {
    setOpenLeaveEndPopup(false);
    dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
    const chimeLocalParticipantId = localStorage.getItem("chimeLocalParticipantId");
    localStorage.setItem("isManualLeft", "yes");
    if (meetComponent === "liveclass" && chimeLocalParticipantId && selectedClassRoomId && selectedSubjectId && currentSessionId) {
        await deleteSessionParticipant({
          variables: {
            cId: selectedClassRoomId,
            sId: currentSessionId,
            sjId: selectedSubjectId,
            participantId: `${chimeLocalParticipantId}`,
          },
        });
    }
    await leaveMeeting();
    
    // Close the window instead of navigating
    closeWindow(locationState);
  };

  const handleEndMeetingHost = () => {
    const isWorkshopHost = (role === SCHOOL_ADMIN || userId === hostId) && meetComponent === "workshop";
    const isLiveclassHost = (role === TEACHER_ROLE || userId === hostId) && meetComponent === "liveclass";
    const isPtaHost = (role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN || userId === hostId) && meetComponent === "pta";
    
    if (isWorkshopHost || isLiveclassHost || isPtaHost) {
      setPromptMessage("Are you sure you want to End the meeting for everyone?");
      setOpenConfirmationPopup(true);
      setAction("end");
    }
    setOpenLeaveEndPopup(false)
  };

  const handleClosePopup = () =>{
    setOpenLeaveEndPopup(false)
  }

  const attemptToPromoteNewHost = async (newHostId:string, newHostAttendeeId:string) => {
    console.log("mediapipeline arn and media pipeline id", mediaPipelineArn, mediaPipelineId);
    console.log("currentSessionDetail", currentSessionDetail);

    const message = JSON.stringify({
            action: "host-changed",
            hostId: newHostId,
            hostAttendeeId: newHostAttendeeId,
            ...((mediaPipelineId || currentSessionDetail?.mediaPipelineId) && {
              mediaPipelineId: currentSessionDetail.mediaPipelineId ?? mediaPipelineId ,
            }),
            ...((mediaPipelineArn || currentSessionDetail?.mediaPipelineArn) && {
              mediaPipelineArn: currentSessionDetail.mediaPipelineArn ?? mediaPipelineArn,
            }),
          });

          console.log("message is ", message);

          console.log("meetingManger", meetingManager?.meetingSession);
          console.log("audioVideo", meetingManager?.meetingSession?.audioVideo);
          console.log("realtimeSendDataMessage", meetingManager?.meetingSession?.audioVideo?.realtimeSendDataMessage);
          meetingManager.meetingSession?.audioVideo?.realtimeSendDataMessage(
            "live-update",
            message
          );
          
          if(meetComponent === 'workshop') {
            await updateWorkshopSessionRecord({
              variables: {
                updateInput: {
                  hostId: newHostId,
                },
                wsId: currentWorkshopId,
              },
            });
          } else if(meetComponent === 'liveclass') {
            await updateHostIdForLiveclass({
              variables: {
                input: {
                  pCId: selectedClassRoomId,
                  pSubjectId: selectedSubjectId,
                  pSessionId: currentSessionId,
                  pHostId: newHostId,
                  pUpdateOriginal: false
                }
              }
            })
          } else if(meetComponent === 'pta') {
            console.log("going to update the latest the host", currentSessionDetail,currentPtaMeetMCode, userId, currentPtaMeetId);
            await updateHostIdForPtaMeeting({
              variables: {
                updateInput: {
                  mCode: currentPtaMeetMCode,
                  hostId: userId,
                },
                mId: currentPtaMeetId,
              }
            })
          }
  }  
  
  function isValidAttendeeId(attendeId: string): boolean {
  const regex = /^[a-fA-F0-9]{8}(?:-[a-fA-F0-9]{4}){3}-[a-fA-F0-9]{12}$/;
  return regex.test(attendeId);
}

async function meetingExists(meetId: string): Promise<boolean> {
  try {
    const participants = await getChimeParticipants(meetId);
    console.log("participants are", participants);

    const attendees = participants?.Attendees;
    if (Array.isArray(attendees) && attendees.length === 0) {
      return false;
    } 
    
    if (Array.isArray(attendees) && attendees.length > 0) {
      return true;
    }

    return false;
  } catch (err) {
    console.warn("Meeting does not exist or already ended:", err);
    return false;
  }
}

  async function fetchChimeAttendeeIdSet(meetId?: string): Promise<Set<string>> {
    const set = new Set<string>();
    if (!meetId) {
      return set;
    }

    const participants = await getChimeParticipants(meetId);
    const attendees = participants?.Attendees ?? [];
    attendees.forEach((attendee) => {
      if (attendee.AttendeeId) {
        set.add(attendee.AttendeeId);
      }
    });

    return set;
  }

  const attemptHostPromotion = async (meetId: string, leavingAttendeeId: string) => {
    const attendeeSet = await fetchChimeAttendeeIdSet(meetId);
    console.log("Promoting new host. Chime attendees:", Array.from(attendeeSet));

    console.log("Current roster:", roster);

    const sanitizedRoster = Object.fromEntries(
      Object.entries(roster)
        .filter(
          ([, attendee]) =>
            !attendee?.chimeAttendeeId?.includes(leavingAttendeeId!) &&
            (!attendeeSet || attendeeSet.has(attendee.chimeAttendeeId))
        )
        .map(([id, attendee]) => [id, { ...attendee, name: attendee.name ?? "" }])
    );

    console.log("Sanitized roster:", sanitizedRoster);

    const newHost = getNewHost(sanitizedRoster);

    console.log("New host selected:", newHost);

    if (!newHost) {
      return false;
    }

    localStorage.setItem("hostId", newHost.externalUserId ?? "");
    localStorage.setItem("hostAttendeeId", newHost.chimeAttendeeId ?? "");
    setHostId(newHost.externalUserId ?? "");
    setHostAttendeeId(newHost.chimeAttendeeId ?? "");

    await attemptToPromoteNewHost(newHost.externalUserId ?? "", newHost.chimeAttendeeId ?? "");
    return true;
  };

  useEffect(() => {
  const audioVideo = meetingManager?.meetingSession?.audioVideo;
  console.log("audioVideo in presence effect:", audioVideo);
  if (!audioVideo) return;

  const handlePresenceChange = async(attendeeId: string, present: boolean) => {
    console.log("Checking presence:", attendeeId, present);
    console.log("host attendeeId:", hostAttendeeId);
    console.log("isValidAttendeeId(attendeeId)", isValidAttendeeId(attendeeId));
    console.log("[inside presence] meeting is", meetingId);

    if(isValidAttendeeId(attendeeId)){
      if(meetingId && !present){
        const exists = await meetingExists(meetingId);
        if (exists) {
          await deleteChimeAttendee(meetingId, attendeeId);
        } else {
          console.log("Skipping delete: Meeting already ended.");
        }
        // await deleteChimeAttendee(meetingId, attendeeId);
      }
      // Compare with your hostId
      if (meetingId && attendeeId === hostAttendeeId && !present) {
        console.log("Host has left the meeting!");

        let success = await attemptHostPromotion(meetingId, attendeeId);

        if (!success) {
          const RETRIES = [500, 1000]; // ms delays
          for (const wait of RETRIES) {
            console.log(`Retrying host promotion after ${wait}ms...`);
            await delay(wait);
            success = await attemptHostPromotion(meetingId, attendeeId);
            if (success) {
              break;
            }
          }
        }

        if (!success) {
          console.warn("No valid new host found even after retries.");
        }
      }

      } else if (attendeeId !== hostAttendeeId && !present) {
        console.log("normal participant left.")
    }
  };

  audioVideo.realtimeSubscribeToAttendeeIdPresence(handlePresenceChange);

  return () => {
    audioVideo.realtimeUnsubscribeToAttendeeIdPresence(handlePresenceChange);
  };
}, [hostId, hostAttendeeId, roster, meetingManager]);

  useEffect(() => {
    const handleBackOrSwipe = async (event: PopStateEvent) => {
      console.log("Back button or swipe-back detected");
      dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
      if(localStorage.getItem("closewindow") !== "called"){
      localStorage.setItem("wayOfLeft", "invalid");
      }
      localStorage.setItem("isJoined", "left");
      try {
        await leaveMeeting();
        closeWindow(locationState);
      } catch (err) {
        console.error("leaveMeeting failed", err);
        closeWindow(locationState);
      }
    };

    window.addEventListener("popstate", handleBackOrSwipe);

    return () => {
      setTimeout(() => {
        window.removeEventListener("popstate", handleBackOrSwipe);
      }, 0);
    };
  }, [leaveMeeting]);

  useEffect(() => {
    return () => {
      setIsShowParticipants(false);
    }
  }, []);

    useEffect(() => {
        const accessTokenInterval = setInterval(async () => {
            const token = localStorage.getItem(
                Object.keys(localStorage).find((key) => key.includes('accessToken')) as string
            );
            // If token is missing => force leave meeting
            if (!token) {
                console.log("[Log] meetingState from localStorage", locationState);
                if(meetComponent === 'liveclass' && role === TEACHER_ROLE){
                    onYesButtonClick("auto", "end");
                } else if(meetComponent === 'workshop' && role === SCHOOL_ADMIN){
                    onYesButtonClick("auto", "end");
                } else if(meetComponent === 'pta' && role === SCHOOL_ADMIN){
                    onYesButtonClick("auto", "end");
                } else {
                    console.log("[Log] Leaving meeting as participant else", role , meetComponent);
                    onYesButtonClick("auto", "leave");
                }
                clearInterval(accessTokenInterval);
            }

        }, 1000);   
        
        return () => {
            clearInterval(accessTokenInterval);
        }
    }, []);  

  return (
    <div className="meet-controls">
      {getScreenDimensions()?.isMobileScreen ? (
        <div className="meet-controls-main">
          {videoEnabled ? (
            <div onClick={() => toggleVideo()}>
              <img
                src={VideoOn}
                alt="videoOn"
                className="videoOnIcon"
                // style={{ marginLeft:isRecording && userId === hostId? 60:0 }}
              />
            </div>
          ) : (
            <div onClick={() => toggleVideo()}>
              <img
                src={VideoOff}
                alt="videoOff"
                className="VideoIcon"
                // style={{ marginLeft:isRecording && userId === hostId? 60:0 }}
              />
            </div>
          )}
          {muted ? (
            <div onClick={() => toggleMute()}>
              <img src={MicOff} alt="videoOn" className="AudioIcon" />
            </div>
          ) : (
            <div onClick={() => toggleMute()}>
              <img src={MicOn} alt="videoOn" className="AudioOnIcon" />
            </div>
          )}
          <div onClick={(e) => handleClickEndButton(e)}>
            <img src={EndCall} alt="videoOff" className="EndCallIcon" />
          </div>
          {isShowParticipants ? (
            <div onClick={() => setIsShowParticipants(false)}>
              <img
                src={selectedAllParticipants}
                alt="Participants"
                className="Participants"
              />
            </div>
          ) : (
            <div onClick={() => setIsShowParticipants(true)}>
              <img
                src={mobileParticipants}
                alt="Participants"
                className="Participants"
              />
            </div>
          )}
          {/* <AudioInputControl /> */}
          {isHandRaised ? (
            <div onClick={() => toggleHandRaise()}>
              <img src={HandOn} alt="videoOn" className="HandIcon" />
            </div>
          ) : (
            <div onClick={() => toggleHandRaise()} className="Hand">
              <img src={HandOff} alt="videoOn" className="HandOffIcon" />
            </div>
          )}
          {isRecording && userId === hostId ? (
            <div
              onClick={handleStopRecording}
              className={` ${
                startRecordingInProgress || stopRecordingInProgress
                  ? BUTTON_DISABLED
                  : ""
              }`}
            >
              <button
                className="toolbox-icon"
                style={{
                  height: "52px",
                  width: "52px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "none",
                  boxShadow: "inset 0 0 0 2px #fff",
                  borderRadius: "50%",
                  cursor: "pointer",
                  marginRight: 20,
                }}
              >
                <IconStopRecording style={{ pointerEvents: "none" }} />

                {/* <IconStartRecording style={{ pointerEvents: "none" }} /> */}
              </button>
            </div>
          ) : (
            userId === hostId && (
              <div
                onClick={handleStartRecording}
                // className={`recordIconContainer ${
                //   startRecordingInProgress || stopRecordingInProgress
                //     ? BUTTON_DISABLED
                //     : ""
                // }`}
              >
                {/* <RadioButtonCheckedIcon className="recordingStartIcon" sx={{
                              color: 'red',
                              height: '35px',
                              width: '52px'
                          }}/> */}
                <button
                  className="toolbox-icon"
                  style={{
                    height: "52px",
                    width: "52px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "none",
                    boxShadow: "inset 0 0 0 2px #fff",
                    borderRadius: "50%",
                    cursor: "pointer",
                    marginRight: 20,
                  }}
                >
                  <IconStartRecording style={{ pointerEvents: "none" }} />
                </button>
              </div>
            )
          )}
        </div>
      ) : (
        <div className="meet-controls-main">
          {!sharingContent && !isPlatform("android") && (
            <div onClick={handleShareScreen}>
              <img
                src={ScreenSharingIcon}
                alt="screenshare"
                className="ScreenShareIcon"
              />
            </div>
          )}
          {/* <VideoInputControl className={videoEnabled ? "videoEnabled" : "videoDisabled"} /> */}
          {videoEnabled ? (
            <div onClick={() => toggleVideo()}>
              <img src={VideoOn} alt="videoOn" className="videoOnIcon" />
            </div>
          ) : (
            <div onClick={() => toggleVideo()}>
              <img src={VideoOff} alt="videoOff" className="VideoIcon" />
            </div>
          )}
          <div onClick={(e) => handleClickEndButton(e)}>
            <img src={EndCall} alt="videoOff" className="EndCallIcon" />
          </div>
          {muted ? (
            <div onClick={() => toggleMute()}>
              <img src={MicOff} alt="videoOn" className="AudioIcon" />
            </div>
          ) : (
            <div onClick={() => toggleMute()}>
              <img src={MicOn} alt="videoOn" className="AudioOnIcon" />
            </div>
          )}
          {/* <AudioInputControl /> */}
          {isHandRaised ? (
            <div onClick={() => toggleHandRaise()}>
              <img src={HandOn} alt="videoOn" className="HandIcon" />
            </div>
          ) : (
            <div onClick={() => toggleHandRaise()} className="Hand">
              <img src={HandOff} alt="videoOn" className="HandOffIcon" />
            </div>
          )}
          {isRecording && (userId === hostId) ? (
            <div
              onClick={handleStopRecording}
              className={`recordIconContainer ${
                startRecordingInProgress || stopRecordingInProgress
                  ? BUTTON_DISABLED
                  : ""
              }`}
            >
              <img
                src={StopIconRed}
                className="recordingStopIcon"
                alt="recording stop"
              />
            </div>
          ) : (
            userId === hostId && (
              <div
                onClick={handleStartRecording}
                className={`recordIconContainer ${
                  startRecordingInProgress || stopRecordingInProgress
                    ? BUTTON_DISABLED
                    : ""
                }`}
              >
                <RadioButtonCheckedIcon
                  className="recordingStartIcon"
                  sx={{
                    color: "red",
                    height: "35px",
                    width: "35px",
                  }}
                />
              </div>
            )
          )}
        </div>
      )}

      <MaterialActionsOverlay
        anchorEl={anchorEl}
        open={openOverlay}
        handleClose={handleCloseActions}
        menuItems={menuItems}
        actionsHeight={"84px"}
        position="center"
        verticalPosition="top"
        module={`meetControls`}
      />
  {/* pop up for leave and end for host */}
      <ConfirmationPopup
        open={openLeaveEndPopup}
        message={promptMessage}
        gifData={Crying}
        yesButtonFunctionality={handleLeaveMeetingHost}
        noButtonFunctionality={handleEndMeetingHost}
        closeFunctionality = {handleClosePopup}
        messageWidth={"264px"}
        page="meeting"
      />

      {/* This popup is only for leave option popup */}
      <ConfirmationPopup
        open={openConfirmationPopup}
        message={promptMessage}
        gifData={Crying}
        yesButtonFunctionality={() => onYesButtonClick("confirmationPopup", action)}
        noButtonFunctionality={onNoButtonClick}
        messageWidth={"264px"}
      />
      <Menu
        anchorEl={anchorElHost}
        open={Boolean(anchorElHost)}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: 2,
            },
          },
        }}
      >
        <MenuItem onClick={handleLeaveMeetingHost}>Leave Meeting</MenuItem>
        <MenuItem onClick={handleEndMeetingHost}>End Meeting</MenuItem>
      </Menu>
    </div>
  );
};

export default ChimeMeetControls;
